import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const FutureEngineering = () => {
  return (
    <section className="py-24 bg-[#4D4C4A] text-white relative">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="mb-12"
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-8 italic">Engineering the Future of Smart Buildings</h2>
            <p className="text-3xl md:text-5xl font-bold italic leading-tight mb-12 tracking-tighter">
              As cities grow and buildings become more technologically advanced, the need for integrated engineering systems continues to increase.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-12 text-left">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.8 }}
              className="p-8 border border-white/5 bg-white/[0.02] hover:bg-white/[0.05] transition-colors duration-300"
            >
              <Icon name="Cpu" size={32} className="text-[#91756A] mb-6" />
              <p className="text-white/80 leading-relaxed italic font-light text-lg">
                At VASTECH, we combine precision engineering, predictive intelligence, and human-centric design to 
                develop solutions that enhance both building performance and user experience.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4, duration: 0.8 }}
              className="p-8 border border-white/5 bg-white/[0.02] hover:bg-white/[0.05] transition-colors duration-300"
            >
              <Icon name="Globe" size={32} className="text-[#91756A] mb-6" />
              <p className="text-white/80 leading-relaxed italic font-light text-lg">
                By aligning our solutions with the UAE vision for modern infrastructure, we contribute to the development 
                of environmentally responsible and technologically advanced built environments.
              </p>
            </motion.div>
          </div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="mt-16 text-white/40 text-xs uppercase tracking-[0.5em] font-bold"
          >
            Smart • Connected • Sustainable
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FutureEngineering;